import { render, staticRenderFns } from "./appraisalOrganSetupUpdate.vue?vue&type=template&id=2f5ba11c&scoped=true"
import script from "./appraisalOrganSetupUpdate.vue?vue&type=script&lang=js"
export * from "./appraisalOrganSetupUpdate.vue?vue&type=script&lang=js"
import style0 from "./appraisalOrganSetupUpdate.vue?vue&type=style&index=0&id=2f5ba11c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ba11c",
  null
  
)

export default component.exports